import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { forwardRef } from "react";
import { styled } from "@mui/material";
import { Spacing } from "../../foundations/spacing.es.js";
import Badge$1 from "../../../node_modules/@mui/material/Badge/Badge.es.js";
const MUI_BADGE_CLASS = "MuiBadge-badge";
const SmallBadge = styled(Badge$1)({
  [`& .${MUI_BADGE_CLASS}`]: {
    height: Spacing["1000"],
    padding: `${Spacing["0"]} 0.375rem`,
    minWidth: "auto"
  }
});
const MediumBadge = styled(Badge$1)({
  [`& .${MUI_BADGE_CLASS}`]: {
    padding: `${Spacing["0"]} 0.40625rem`
  }
});
const BADGE_MAX_VALUE = 99;
const Badge = forwardRef(function Badge2({
  children,
  size,
  ...rest
}, ref) {
  const badgeProps = {
    ref,
    max: BADGE_MAX_VALUE,
    ...rest
  };
  if (rest.variant === "dot") {
    return /* @__PURE__ */ jsx(Badge$1, { ...badgeProps, children });
  }
  if (size === "small") {
    return /* @__PURE__ */ jsx(SmallBadge, { ...badgeProps, children });
  }
  return /* @__PURE__ */ jsx(MediumBadge, { ...badgeProps, children });
});
export {
  Badge
};
//# sourceMappingURL=badge.es.js.map
